import { render, staticRenderFns } from "./TempalteSelector.vue?vue&type=template&id=fc2e36de&"
import script from "./TempalteSelector.vue?vue&type=script&lang=js&"
export * from "./TempalteSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports